type ExpressionResult = string | boolean | string[] | undefined | null

export type ConstValue = {
  type: 'constValue',
  value: ExpressionResult,
}

export type ContextValue = {
  type: 'contextValue',
  key: string,
}

type Value = ContextValue | ConstValue
type Context = Record<string, ExpressionResult>

export type Expression = {
  type: 'expression',
  name: 'equals' | 'includes' | 'not' | 'or' | 'and',
  args: (Expression | Value)[]
}

const getValue = (x: Value, context: Context): ExpressionResult => {
  if (x.type === 'contextValue') {
    return context[x.key];
  }
  return x.value;
};

const isExpression = (obj: { type: string }): obj is Expression => obj.type === 'expression';

export const evaluateExpression = (obj: Expression | Value, context: Context = {}): ExpressionResult => {
  const operations: Record<Expression['name'], (...args: ExpressionResult[]) => ExpressionResult> = {
    equals: (...args) => args[0] === args[1],
    includes: (...args) => args[0] && Array.isArray(args[0]) ? args[0].includes(args[1] as string) : false,
    not: (...args) => !args[0],
    and: (...args) => args[0] && args[1],
    or: (...args) => args[0] || args[1],
  };
  if (isExpression(obj)) {
    return operations[obj.name](...obj.args.map(arg => evaluateExpression(arg, context)));
  }
  return getValue(obj, context);
};
